import { node, string } from 'prop-types';
import './index.scss';


const CheckboxButtonGroup = (props) => {

    return (
        <div className="checkbox-button-group">
            {props.label && (
                <label className="form-label">{props.label}</label>
            )}
            <div className="checkbox-button-row">
                {props.children}
            </div>
        </div>
    );
};

CheckboxButtonGroup.propTypes = {
    children: node.isRequired,
    label: string
};

CheckboxButtonGroup.defaultProps = {
    label: ''
};

export default CheckboxButtonGroup;
